import { getPath } from '@/router/common'

const baseUrl = {
  title: '费用支出登记',
  path: 'OtherFee'
}

export default [
  {
    path: getPath('OtherFeeList', baseUrl),
    name: 'OtherFee_OtherFeeList',
    component: () => import(/* webpackChunkName: "OtherFee_OtherFeeList" */ '@/views/otherFee/otherFeeList/index.vue'),
    meta: {
      title: '费用支出登记'
    }
  },
  {
    path: getPath('AccTypeMana', baseUrl),
    name: 'OtherFee_AccTypeMana',
    component: () => import(/* webpackChunkName: "OtherFee_AccTypeMana" */ '@/views/otherFee/accTypeMana/index.vue'),
    meta: {
      title: '费用支出类型维护'
    }
  },
  {
    path: getPath('OtherFeeAdd', baseUrl),
    name: 'OtherFee_OtherFeeAdd',
    component: () => import(/* webpackChunkName: "OtherFee_OtherFeeAdd" */ '@/views/otherFee/otherFeeAdd/index.vue'),
    meta: {
      title: '费用支出登记|修改'
    }
  }
]
